import React from 'react';
import { ClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
const pillars = [{
  title: 'Built for Everyday Supervisory Work',
  desc: 'Created for professionals who need useful structures and clear starting points—not complicated AI workflows or advanced technical skills.'
}, {
  title: '100+ Ready-to-Use Prompts',
  desc: 'Copy, customize the relevant details, and use your preferred AI assistant to help prepare a first draft, organize information, or structure a task.'
}];
export function SystemIntro() {
  const {
    mm,
    ss,
    deadline
  } = useCountdown();
  const deadlineLabel = deadline.toLocaleTimeString([], {
    hour: 'numeric',
    minute: '2-digit'
  });
  return <section aria-label="About the system" className="bg-transparent" data-id="element-279" data-mp="1pi9zid3rdhdu">
      <div className="mx-auto max-w-5xl px-5 pb-10 pt-4" data-id="element-280" data-mp="2vy2j97g52t05">
        

        <h2 className="mx-auto mt-10 max-w-3xl text-center font-display text-[25px] font-black uppercase leading-tight text-plum sm:text-4xl" data-id="element-281" data-mp="2vzx1uf3xu912">
          A practical system for the realities of supervision
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-center text-base leading-relaxed text-plum/70" data-id="element-282" data-mp="11hbox28jknwv">
          Supervision involves much more than assigning tasks. It means coordinating people, communicating expectations, documenting activities, solving problems, tracking progress, and making sure important details do not get overlooked.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-center text-base font-semibold leading-relaxed text-plum" data-id="element-283" data-mp="mlcgfqhislr7">
          100+ AI PROMPTS FOR SUPERVISORS™ is designed to help you approach these responsibilities with a more organized, repeatable process.
        </p>

        <div className="mt-10 grid border-y border-grape-soft/40 sm:grid-cols-3 sm:divide-x sm:divide-grape-soft/40" data-id="element-284" data-mp="8swk18j4jlz9">
          {pillars.map(p => <div key={p.title} className="border-b border-grape-soft/40 px-2 py-6 last:border-b-0 sm:border-b-0 sm:px-6" data-id="element-285" data-mp="3ss69q9lp5cq">
              <h3 className="font-display text-base font-black text-plum" data-id="element-286" data-mp="3v1xisofncglc">{p.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-plum/65" data-id="element-287" data-mp="3le20oq3syeke">{p.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}